import React, { useState } from 'react';
import { signIn, resetPassword, signInWithGoogle } from '../services/authService'; // Assuming correct path
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useNavigate } from 'react-router-dom'; // Link is now in AuthFormLayout
import { Button, Form, Spinner, InputGroup } from 'react-bootstrap';

import AuthPageLayout from '../components/AuthPageLayout';
import AuthFormLayout from '../components/AuthFormLayout';
// CSS files are now mainly imported by the layout components, but keep if LoginPage has specific styles not covered.
// import './AuthPage.css';
// import './LoginPageSidePanel.css';


const LoginPage = ({ setUser }) => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' }); // For password reset
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleInputChange = (e) => { const { name, value } = e.target; setFormData({ ...formData, [name]: value }); };
    const togglePasswordVisibility = () => setShowPassword(!showPassword);

    const handleGoogleSuccess = async (credentialResponse) => {
        setErrorMsg('');
        setSubmitStatus({ type: '', message: '' });
        setIsSubmitting(true);
        try {
            const { user } = await signInWithGoogle(credentialResponse);
            if (user) {
                setUser(user); navigate('/app');
            } else {
                setErrorMsg('Could not retrieve user information after Google login.');
            }
        } catch (err) { setErrorMsg(err.message || 'Google login failed.'); } finally { setIsSubmitting(false); }
    };
    const handleGoogleError = () => { setErrorMsg('Google Login failed. Please try again.'); };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setErrorMsg(''); setSubmitStatus({ type: '', message: '' });
        setIsSubmitting(true);
        try {
            const { data, error } = await signIn({ email: formData.email, password: formData.password });
            if (error) throw error;
            setUser(data.user);
            navigate('/app');
        } catch (err) {
            setErrorMsg(err.message || 'Login failed. Please check your credentials.');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleResetPassword = async () => {
        if (!formData.email) {
            setErrorMsg("Please enter your email to reset your password.");
            setSubmitStatus({ type: '', message: '' });
            return;
        }
        setErrorMsg('');
        setSubmitStatus({ type: '', message: '' }); // Clear previous messages
        setIsSubmitting(true); // Consider a different state for reset password if it can happen concurrently
        try {
            await resetPassword(formData.email);
            setSubmitStatus({ type: 'success', message: 'Password reset email sent! Please check your inbox.' });
        } catch (err) {
            // Use submitStatus for error from reset password to distinguish from login errorMsg
            setSubmitStatus({ type: 'danger', message: "Error resetting password: " + (err.message || "Unknown error") });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <AuthPageLayout>
            <AuthFormLayout
                pageTitle="Welcome Back!"
                errorMsg={errorMsg}
                setErrorMsg={setErrorMsg}
                submitStatus={submitStatus}
                setSubmitStatus={setSubmitStatus}
                onGoogleSuccess={handleGoogleSuccess}
                onGoogleError={handleGoogleError}
                toggleLinkPath="/register"
                toggleLinkText="Sign Up"
                toggleQuestionText="Don't have an account?"
            >
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3 floating-label-group">
                        <Form.Control type="email" id="emailLogin" name="email" value={formData.email} onChange={handleInputChange} placeholder=" " required />
                        <Form.Label htmlFor="emailLogin"><FontAwesomeIcon icon={faEnvelope} className="me-2" />Email Address</Form.Label>
                    </Form.Group>

                    <Form.Group className="mb-3 floating-label-group">
                        <InputGroup>
                            <Form.Control type={showPassword ? "text" : "password"} id="passwordLogin" name="password" value={formData.password} onChange={handleInputChange} placeholder=" " required />
                            <Button variant="outline-secondary" onClick={togglePasswordVisibility} aria-label={showPassword ? "Hide password" : "Show password"}>
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                            </Button>
                        </InputGroup>
                        <Form.Label htmlFor="passwordLogin">Password</Form.Label>
                    </Form.Group>

                    <div className="mt-2 text-end mb-3">
                        <Button variant="link" type="button" className="p-0 forgot-password-link" onClick={handleResetPassword} disabled={isSubmitting}>
                            Forgot your password?
                        </Button>
                    </div>

                    <Button type="submit" className="w-100 text-white mt-3 main-action-button" disabled={isSubmitting}>
                        {isSubmitting ? <Spinner animation="border" size="sm" className="me-2" /> : ''}
                        Login
                    </Button>
                </Form>
            </AuthFormLayout>
        </AuthPageLayout>
    );
};

export default LoginPage;